import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL, PHONE, PHONE_TEL, EMAIL } from "../data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#12081D]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="mb-4">
            <img src={LOGO_URL} alt="GlowMode Lighting" className="h-12 w-60 object-cover object-center mix-blend-screen" />
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">Life looks better in Glow Mode. Luxury residential & commercial lighting installation, designed and cut for your property.</p>
        </div>

        <div>
          <h4 className="text-xs font-mono uppercase tracking-[0.25em] text-gold mb-5">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li>
              <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-3 hover:text-gold-light transition-colors">
                <Phone className="h-4 w-4 text-gold shrink-0" /> {PHONE}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-3 hover:text-gold-light transition-colors break-all">
                <Mail className="h-4 w-4 text-gold shrink-0" /> {EMAIL}
              </a>
            </li>
            <li className="flex items-start gap-3 text-slate-400">
              <MapPin className="h-4 w-4 text-gold shrink-0 mt-0.5" />
              <span>Serving all of Salt Lake County. Utah, Davis & Weber counties available for a small travel fee.</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-mono uppercase tracking-[0.25em] text-gold mb-5">Explore</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><Link to="/services" data-testid="footer-services-link" className="hover:text-gold-light transition-colors">Lighting Services</Link></li>
            <li><Link to="/gallery" data-testid="footer-gallery-link" className="hover:text-gold-light transition-colors">Project Gallery</Link></li>
            <li><Link to="/holiday" data-testid="footer-holiday-link" className="hover:text-gold-light transition-colors">Holiday Lighting — 50% Off Promo</Link></li>
            <li><Link to="/reviews" data-testid="footer-reviews-link" className="hover:text-gold-light transition-colors">Customer Reviews</Link></li>
            <li><Link to="/book" data-testid="footer-book-link" className="hover:text-gold-light transition-colors">Book a Free Quote</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-slate-500 font-mono tracking-wider">
        © {new Date().getFullYear()} GlowMode Lighting · GlowModeLighting.com · Salt Lake County, UT
      </div>
    </footer>
  );
}
